import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  execute2yvxycsuayg6m as execute,
  link1g490lyf7zi1a as link,
  SimpleSuspendAction15o5glu1onh36 as SimpleSuspendAction,
} from '../../../../../../testmints-action-async/com/zegreatrob/testmints/action/async/SimpleSuspendAction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var GqlQuery$Dispatcher$perform$refClass;
function GqlQuery$Dispatcher$perform$ref() {
  if (GqlQuery$Dispatcher$perform$refClass === VOID) {
    class $ {
      *b6s(p0, p1, $completion) {
        return yield* p0.j6r(p1, $completion);
      }
      md(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Dispatcher()) : false) ? p1 : THROW_CCE();
        return this.b6s(tmp, p2 instanceof GqlQuery() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [2]);
    GqlQuery$Dispatcher$perform$refClass = $;
  }
  return GqlQuery$Dispatcher$perform$refClass;
}
function GqlQuery$Dispatcher$perform$ref_0() {
  var i = new (GqlQuery$Dispatcher$perform$ref())();
  var l = (p0, p1, $completion) => i.b6s(p0, p1, $completion);
  l.callableName = 'perform';
  l.$arity = 2;
  return l;
}
var GqlQueryClass;
function GqlQuery() {
  if (GqlQueryClass === VOID) {
    class $ {
      constructor(query) {
        this.v6r_1 = query;
        var tmp = this;
        tmp.w6r_1 = this.a2f(this, GqlQuery$Dispatcher$perform$ref_0());
      }
      p2e() {
        return this.w6r_1;
      }
      toString() {
        return 'GqlQuery(query=' + toString(this.v6r_1) + ')';
      }
      hashCode() {
        return hashCode(this.v6r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GqlQuery()))
          return false;
        if (!equals(this.v6r_1, other.v6r_1))
          return false;
        return true;
      }
    }
    protoOf($).v2e = execute;
    protoOf($).a2f = link;
    initMetadataForClass($, 'GqlQuery', VOID, VOID, [SimpleSuspendAction()], [1]);
    GqlQueryClass = $;
  }
  return GqlQueryClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher2xvjdz9qh940,
  GqlQuery as GqlQueryfz0vfezppkdu,
};
//endregion

//# sourceMappingURL=GqlQuery.mjs.map
